import { createFileRoute } from '@tanstack/react-router';
import { PartnerInfoHubPage } from '@/pages/partner/info-hub/PartnerInfoHubPage';

export const Route = createFileRoute('/partner/info-hub')({
  component: PartnerInfoHubPage
});
